import { Section } from 'components/Section';
import styles from './article.scss';
import { ArticleBlock } from 'models/ArticleBlock';
import Image from 'components/Shared/Image';
import { NO_ELEMENT } from 'utils';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { isMobile } from 'components/Shared/responsive';
import { getMacro } from 'components/Macro';

const ARTICLE_MAIN_IMAGE_DIMENSIONS = {
  height: 450,
  width: 1500
};

type ArticleMetadataProps = Pick<
  ArticleBlock,
  'categoryName' | 'editorialType' | 'modifiedDate' | 'articleCategoryImage'
> & {
  author: ArticleBlock['article']['author'];
};

const AuthorData = ({
  author,
  modifiedDate
}: Pick<ArticleMetadataProps, 'author' | 'modifiedDate'>) => {
  return (
    <div className={styles.seperator}>
      <p className={styles.author}>
        Av {author} • <span className={styles.date}>{modifiedDate}</span>
      </p>
    </div>
  );
};

export const Article = ({ article, content, modifiedDate }: ArticleBlock) => {
  const mobile = useSelector(isMobile);
  const components = getMacro(content);

  return (
    <Section>
      <div>
        <div className={styles.fullWidth}>
          <h1
            className={cn(styles.header, {
              [styles.mobileHeader]: mobile,
              [styles.desktopHeader]: !mobile
            })}
          >
            {article.title}
          </h1>
          {article.hasMainImage ? (
            <>
              <Image
                className={styles.articleMainImage}
                paddingBottom
                src={article.largeMainImage}
                wrapperClassName={cn(styles.fullWidth, styles.imageWrapper)}
                alt={article.mainImageCaption}
                {...ARTICLE_MAIN_IMAGE_DIMENSIONS}
              />
              {article.mainImageCaption ? (
                <p className={styles.articleMainImageCaption}>{article.mainImageCaption}</p>
              ) : (
                NO_ELEMENT
              )}
            </>
          ) : (
            NO_ELEMENT
          )}
          <p className={styles.intro}>{article.introduction}</p>
          <AuthorData author={article.author} modifiedDate={modifiedDate} />
        </div>
      </div>
      <div className={styles.articleContainer}>{components}</div>
    </Section>
  );
};
